/* global interfaceConfig */

import React from "react";

import { isMobileBrowser } from "../../base/environment/utils";
import { translate, translateToHTML } from "../../base/i18n";
import { Icon, IconWarning } from "../../base/icons";
import { Watermarks } from "../../base/react";
import { connect } from "../../base/redux";
import { CalendarList } from "../../calendar-sync";
import { RecentList } from "../../recent-list";
import { SettingsButton, SETTINGS_TABS } from "../../settings";

import { AbstractWelcomePage, _mapStateToProps } from "./AbstractWelcomePage";
import Tabs from "./Tabs";
import AddIcon from "@material-ui/icons/Add";
import moment from "moment";
import Modal from "@material-ui/core/Modal";

import logo from "../../../../images/logo.svg";
import bell from "../../../../images/bell.svg";
import calendar from "../../../../images/calendar.svg";
import warning from "../../../../images/warning.svg";
import people from "../../../../images/people.svg";
import cross from "../../../../images/cross.svg";
import letter from "../../../../images/letter.svg";
import phone from "../../../../images/phone.svg";
import generate from "generate-password";
import "./welcomePage.css";
import "../../../../assetsByAb/assets/bootstrap.min.css";
import "../../../../assetsByAb/assets/My.css";
import Login from "./Login";

import DateTimePicker from "./DateTimePicker";
import ConfirmationModal from "./ConfirmationModal";
import HistoryModal from "./HistoryModal";
import { baseUrl } from "../../../api";
import Survey from "./Survey";
import TerminatePage from "./TerminatePage";
import TerminatePageViaSurvey from "./TerminatePageViaSurvey";
//import { token } from "morgan";
/**
 * The pattern used to validate room name.
 *
 * @type {string}
 */
export const ROOM_NAME_VALIDATE_PATTERN_STR = "^[^?&:\u0022\u0027%#]+$";

/**
 * The Web container rendering the welcome page.
 *
 * @augments AbstractWelcomePage
 */
class WelcomePage extends AbstractWelcomePage {
    /**
     * Default values for {@code WelcomePage} component's properties.
     *
     * @static
     */
    static defaultProps = {
        _room: "",
    };

    /**
     * Initializes a new WelcomePage instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            form: {
                email1: "",
                email2: "",
                email3: "",
            },
            generateRoomnames:
                interfaceConfig.GENERATE_ROOMNAMES_ON_WELCOME_PAGE,
            selectedTab: 0,
            emails: [],
            phoneNumbers: [],
            addPhone: false,
            addEmail: false,
            open: false,
            insertErr: false,
            enterEmail: false,
            displayFeilds: false,
            user_name: "",
            user_email: "",
            user_phone: "",
            surname: "",
            user_name_err: false,
            user_email_err: false,
            user_phone_err: false,
            emailAndPhoneEmpty: false,
            user_detail: [],
            editMode: false,
            editingIndex: "",
            comments: "",
            emails: [],
            email: "",
            phoneNumber: "",
            members: [],
            inputErr: false,
            inputErrMsg: "",
            loading: false,
            recentMeetings: [],
            comment: "",
            selectedHistory: "",
            room: "",
            gender: "",
            clientName: "",
            appointmentDate: moment(new Date()).format(`YYYY-MM-DD`),
            fromDate: moment(new Date()).format(`YYYY-MM-DD`),
            toDate: "",
            hours: "",
            minutes: "",
            confirmationModal: false,
            editedNote: "",
            editedComment: "",
            editNoteMode: false,
            editCommentMode: false,
            dateMode: "nextAppointment",
            showHistoryModal: false,
            loggedInUser: localStorage.getItem("user_details")
                ? JSON.parse(localStorage.getItem("user_details"))
                : false,
            isLoggedIn: localStorage.getItem("user_details") ? true : false,
            showSurvey: sessionStorage.getItem("participantIsUser")
                ? true
                : false,
            terminatePage: sessionStorage.getItem("terminatePage")
                ? true
                : false,
        };

        /**
         * The HTML Element used as the container for additional content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentRef = null;

        this._roomInputRef = null;

        /**
         * The HTML Element used as the container for additional toolbar content. Used
         * for directly appending the additional content template to the dom.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentRef = null;

        this._additionalCardRef = null;

        /**
         * The template to use as the additional card displayed near the main one.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalCardTemplate = document.getElementById(
            "welcome-page-additional-card-template"
        );

        /**
         * The template to use as the main content for the welcome page. If
         * not found then only the welcome page head will display.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalContentTemplate = document.getElementById(
            "welcome-page-additional-content-template"
        );

        /**
         * The template to use as the additional content for the welcome page header toolbar.
         * If not found then only the settings icon will be displayed.
         *
         * @private
         * @type {HTMLTemplateElement|null}
         */
        this._additionalToolbarContentTemplate = document.getElementById(
            "settings-toolbar-additional-content-template"
        );

        // Bind event handlers so they are only bound once per instance.
        this._onFormSubmit = this._onFormSubmit.bind(this);
        this._onRoomChange = this._onRoomChange.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);

        this._setAdditionalCardRef = this._setAdditionalCardRef.bind(this);
        this._setAdditionalContentRef =
            this._setAdditionalContentRef.bind(this);
        this._setRoomInputRef = this._setRoomInputRef.bind(this);
        this._setAdditionalToolbarContentRef =
            this._setAdditionalToolbarContentRef.bind(this);
        this._onTabSelected = this._onTabSelected.bind(this);
        this._renderFooter = this._renderFooter.bind(this);
    }

    /**
     * Implements React's {@link Component#componentDidMount()}. Invoked
     * immediately after this component is mounted.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentDidMount() {
        super.componentDidMount();

        document.body.classList.add("welcome-page");
        document.title = "Ateliers numériques";

        let removeClass = document.querySelector(".cLnhlo");

        removeClass.classList.remove("cLnhlo");

        if (this.state.generateRoomnames) {
            this._updateRoomname();
        }

        if (this._shouldShowAdditionalContent()) {
            this._additionalContentRef.appendChild(
                this._additionalContentTemplate.content.cloneNode(true)
            );
        }

        if (this._shouldShowAdditionalToolbarContent()) {
            this._additionalToolbarContentRef.appendChild(
                this._additionalToolbarContentTemplate.content.cloneNode(true)
            );
        }

        if (this._shouldShowAdditionalCard()) {
            this._additionalCardRef.appendChild(
                this._additionalCardTemplate.content.cloneNode(true)
            );
        }
        this.verifyUrl();
        let loggedIn = JSON.parse(localStorage.getItem("user_details"));
        if (loggedIn) {
            this.getRecentMettings();
        } else {
            // alert("callled")
            localStorage.removeItem("token");
        }
    }
    componentDidUpdate() {
        if (this.state.inputErr) {
            setTimeout(() => {
                this.setState({ ...this.state, inputErr: false });
            }, 3000);
        }
    }
    verifyUrl() {
        let url = window.location.href;
        // let url="https://devmeet.vjoinlife.com/1688741820963YEHAYbQ3?Code_EDO=12345"
        if (url.includes("?")) {
            let a = url.split("?");
            // https://devmeet.vjoinlife.com/1688741820963YEHAYbQ3?Code_EDO=3622
            let b = a[1];
            let c = b.split("=");
            console.log("fetch new url", c[1]);
            let payload = {
                Code_EDO: c[1],
            };
            fetch(`${baseUrl}/code_edo_verify/${c[1]}`, {
                method: "GET",
                // headers: {
                //   token: token,
                //   "Content-Type": "application/json",
                // },
                // body: JSON.stringify(payload),
            })
                .then((response) => response.json())
                .then((res) => {
                    if (res?.statusCode === 200) {
                        let a = url.split("?");

                        let ac = `${a[0]}?jwt=${res.response.token}`;
                        console.log("res.response.detail", ac);
                        window.location.replace(ac);
                        //  let a=res.response.token;
                        //  window.replace()
                        // this.setState({
                        //   ...this.state,
                        //   recentMeetings: res.response.detail,
                        //   recentMeetingsFiltered: res.response.detail,
                        //   loading: false,
                        //   selectedHistory: "",
                        // });
                    } else if (res?.statusCode === 401) {
                        localStorage.removeItem("user_details");
                        localStorage.removeItem("token");
                        window.location.replace("/");
                    }

                    // this.getMeetingId();
                })

                .catch((err) => console.log(err));
        } else {
            console.log("notttt??");
        }
    }
    getRecentMettings() {
        this.setState({ ...this.state, loading: true });
        let userId = JSON.parse(localStorage.getItem("user_details")).user_id;
        let payload = {
            user_id: userId,
            from: this.state.fromDate,
            to: this.state.toDate,
        };
        let token = localStorage.getItem("token");
        if (userId) {
            fetch(`${baseUrl}/meeting_history_n`, {
                method: "POST",
                headers: {
                    token: token,
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            })
                .then((response) => response.json())
                .then((res) => {
                    if (res?.statusCode === 200) {
                        localStorage.setItem(
                            "meetings",
                            JSON.stringify(res.response.detail)
                        );
                        this.setState({
                            ...this.state,
                            recentMeetings: res.response.detail,
                            recentMeetingsFiltered: res.response.detail,
                            loading: false,
                            selectedHistory: "",
                        });
                    } else if (res?.statusCode === 401) {
                        localStorage.removeItem("user_details");
                        localStorage.removeItem("token");
                        window.location.replace("/");
                    }

                    // this.getMeetingId();
                })
                .catch((err) => console.log(err));
        }
    }

    onEmailChange(e) {
        e.persist();
        if (e.target) {
            console.log(e.target.name, e.target.value);
            this.setState((state) => ({
                form: { ...state.form, [e.target.name]: e.target.value },
            }));
        }
    }

    validEmail(val) {
        if (
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                val
            )
        ) {
            return true;
        } else {
            return false;
        }
    }

    sendEmailsArray(param) {
        if (!this.validateInputs()) return;
        let str =
            "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
        let shuffled = str
            .split("")
            .sort(() => 0.5 - Math.random())
            .join("")
            .substr(0, 8);
        let record = {
            user_email: this.state.email || "",
            user_phone: this.state.phoneNumber || "",
            user_name: `${this.state.gender} ${this.state.clientName}`,
            surname: this.state.surname,
        };
        let time =
            param === "startMeeting"
                ? `${new Date().getHours()}:${new Date().getMinutes()}`
                : false;
        let payload = {
            meeting_id: shuffled,
            user_detail: [record],
            comment: this.state.comment,
            appointment_date: this.state.appointmentDate,
            added_by: JSON.parse(localStorage.getItem("user_details")).user_id,
            appointment_time: time
                ? time
                : `${this.state.hours}:${this.state.minutes}`,
        };

        this.setState({
            ...this.state,
            loading: true,
            room: shuffled,
            confirmationModal: false,
        });
        console.log(param, "inside of sendEamilsarray");
        let token = localStorage.getItem("token");
        fetch(`${baseUrl}/emailSendFormeeting_n`, {
            method: "POST", // or 'PUT'
            headers: {
                "Content-Type": "application/json",
                token: token,
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((res) => {
                console.log("response", res);
                // if (!this._roomInputRef || this._roomInputRef.reportValidity()) {
                this.setState({
                    ...this.state,
                    loading: false,
                    apointmentDate: moment(new Date()).format(`YYYY-MM-DD`),
                    surname: "",
                    email: "",
                    phoneNumber: "",
                    clientName: "",
                    comment: "",
                    gender: "",
                    // hours: "",
                    // minutes: "",
                });
                if (param === "startMeeting") {
                    console.log("response", res);
                    sessionStorage.setItem("terminate", "true");
                    localStorage.setItem(
                        "meeting_id",
                        res?.response?.meeting_id
                    );
                    this.joinMeeting(
                        shuffled,
                        res?.response?.meeting_id,
                        res?.response?.user_email,
                        ""
                    );
                } else {
                    this.getRecentMettings();
                }
                // }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    getRecentMettingsByDate(fromDate, toDate) {
        let userId = JSON.parse(localStorage.getItem("user_details")).user_id;
        let url = `${baseUrl}/meeting_history_n`;
        let token = localStorage.getItem("token");

        let payload = {
            user_id: userId,
            from: moment(fromDate).format("YYYY-MM-DD"),
            to: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
        };

        this.setState({ ...this.state, loading: true });
        fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json", token: token },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((res) => {
                if (res?.statusCode === 200) {
                    this.setState({
                        ...this.state,
                        recentMeetings: res.response.detail,
                        recentMeetingsFiltered: res.response.detail,
                        loading: false,
                    });
                } else if (res?.statusCode === 401) {
                    localStorage.removeItem("user_details");
                    localStorage.removeItem("token");
                    window.location.replace("/");
                }
            });
    }

    startMeeting(param) {
        this.sendEmailsArray(param);
    }
    createMeeting(param) {
        this.sendEmailsArray(param);
    }
    handleClose() {
        this.setState({ ...this.state, confirmationModal: false });
    }

    selectedHistory(history) {
        // console.log("selectedHistory",history?.user_detail?.user_email,history?.meeting_id)
        // localStorage.setItem("call-email",history?.user_detail?.user_email)
        // localStorage.setItem("call-id",history?.meeting_id)
        this.setState({
            ...this.state,
            selectedHistory: history,
            showHistoryModal: true,
            editNoteMode: false,
            editCommentMode: false,
        });
    }

    /**
     * Removes the classname used for custom styling of the welcome page.
     *
     * @inheritdoc
     * @returns {void}
     */
    componentWillUnmount() {
        super.componentWillUnmount();

        document.body.classList.remove("welcome-page");
    }

    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement|null}
     */

    searchMeeting(text) {
        let lcText = text.toLowerCase();
        let filtered = this.state.recentMeetingsFiltered?.filter(
            (m) =>
                m.meeting_name.toLowerCase().includes(lcText) ||
                m?.comment?.toLowerCase().includes(lcText) ||
                m?.user_detail?.user_email?.toLowerCase().includes(lcText) ||
                m?.user_detail?.user_name?.toLowerCase().includes(lcText) ||
                m?.user_detail?.user_phone?.toLowerCase().includes(lcText) ||
                m?.user_detail?.notes?.toLowerCase().includes(lcText)
        );
        if (text) {
            //console.log(filtered, "imran");
            this.setState({ ...this.state, recentMeetings: filtered });
        } else {
            this.setState({
                ...this.state,
                recentMeetings: this.state.recentMeetingsFiltered,
            });
        }
    }
    setPhoneNumber(number) {
        let firstCharcter = number.slice(0, 1);
        if (firstCharcter === "0") {
            number = "33" + number.slice(1);
        }
        this.setState({ ...this.state, phoneNumber: number });
    }
    setDate(date) {
        this.setState({ ...this.state, appointmentDate: date });
    }

    validateInputs(param = "") {
        if (this.state.email) {
            if (!this.validEmail(this.state.email)) {
                this.setState({
                    ...this.state,
                    inputErr: true,
                    inputErrMsg: "Adresse e-mail non valide",
                    confirmationModal: false,
                });
                return false;
            }
        }

        if (!this.validEmail(this.state.email) && !this.state.phoneNumber) {
            this.setState({
                ...this.state,
                inputErr: true,
                inputErrMsg:
                    "Veuillez renseigner une adresse e-mail ou un numéro de mobile",
                confirmationModal: false,
            });
            return false;
        }
        let selectedDate = moment(this.state.appointmentDate).format(
            "YYYY-MM-DD"
        );
        let now = moment(new Date()).format("YYYY-MM-DD");

        if (now > selectedDate) {
            this.setState({
                ...this.state,
                inputErr: true,
                inputErrMsg: "Veuillez choisir une date ultérieure",
                confirmationModal: false,
            });
            return false;
        }
        if (param === "createMeeting") {
            if (!this.state.hours) {
                this.setState({
                    ...this.state,
                    inputErr: true,
                    inputErrMsg: "Please select hour",
                    confirmationModal: false,
                });
                return false;
            }
            if (!this.state.minutes) {
                this.setState({
                    ...this.state,
                    inputErr: true,
                    inputErrMsg: "Please select minutes",
                    confirmationModal: false,
                });
                return false;
            }
        }
        return true;
    }

    joinMeeting(name, id, meeting, notes) {
        // console.log("selectedHistory",meeting)
        // let store={email:meeting,
        // id:id}
        console.log("selectedHistory", meeting, id);

        localStorage.setItem("call-email", meeting);
        localStorage.setItem("call-id", id);

        let user = JSON.parse(localStorage.getItem("user_details"));
        let payload = {
            email: user?.user_email,
            id: "abcd:a1b2c3-d4e5f6-0abc1-23de-abcdef01fedcba",
            internal_nick: "guest",
            name: "TEST 1",
        };

        let url = `${baseUrl}/test_token`;
        fetch(url, {
            method: "POST",
            headers: {
                token: localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        })
            .then((res) => res.json())
            .then((res) => {
                if (res?.statusCode === 200) {
                    // let userName = JSON.parse(localStorage.getItem("user_details"))?.shop_name;
                    sessionStorage.setItem("terminate", true);

                    localStorage.setItem("meeting_id", id);
                    localStorage.setItem("notes", notes);
                    // window.open(
                    //   `/${name}#userInfo.displayName="${userName}"`,
                    //   "_blank",
                    //   "location=yes"
                    // );
                    window.open(
                        `/${name}?jwt=${res?.response?.detail}`,
                        "_blank",
                        "location=yes,width=600,height=900"
                    );
                }
            })
            .catch((err) => console.log(err));
    }

    setFromDate(date) {
        let fromDate = date ? date : moment(new Date()).format(`YYYY-MM-DD`);
        if (this.state.toDate) {
            let fromD = moment(fromDate);
            let toD = moment(this.state.toDate);
            if (fromD > toD) {
                this.setState({
                    ...this.state,
                    fromDate: fromDate,
                    inputErr: true,
                    inputErrMsg:
                        "La date de début doit être inférieure à la date de fin",
                });
                return;
            } else {
                this.setState({
                    ...this.state,
                    fromDate: fromDate,
                    loading: true,
                });
            }
        }

        this.getRecentMettingsByDate(fromDate, this.state.toDate);
    }
    setToDate(date) {
        let fromD = moment(this.state.fromDate);
        let toD = moment(date);

        if (fromD > toD) {
            this.setState({
                ...this.state,
                toDate: date,
                inputErr: true,
                inputErrMsg:
                    "La date de début doit être inférieure à la date de fin",
            });
            return;
        } else {
            this.setState({
                ...this.state,
                toDate: date,
                loading: true,
            });
        }

        this.getRecentMettingsByDate(this.state.fromDate, date);
    }

    // login() {
    //   this.setState({ ...this.state, isLoggedIn: true });
    //   this.getRecentMettings();
    // }
    login(user) {
        this.setState({ ...this.state, isLoggedIn: true, loggedInUser: user });
        this.getRecentMettings();
    }

    openModal(mode) {
        this.setState({
            ...this.state,
            meetingMode: mode,
            confirmationModal: true,
        });
    }
    closeHistoryModal(arg) {
        this.setState({ ...this.state, showHistoryModal: false });
        if (arg) {
            this.getRecentMettings();
        }
    }

    logout() {
        localStorage.removeItem("user_details");
        this.setState({ ...this.state, isLoggedIn: false });
    }
    render() {
        // console.log("this.state.form: ", this.state.form);
        const { _moderatedRoomServiceUrl, t } = this.props;
        const { DEFAULT_WELCOME_PAGE_LOGO_URL, DISPLAY_WELCOME_FOOTER } =
            interfaceConfig;
        const showAdditionalCard = this._shouldShowAdditionalCard();
        const showAdditionalContent = this._shouldShowAdditionalContent();
        const showAdditionalToolbarContent =
            this._shouldShowAdditionalToolbarContent();
        const contentClassName = showAdditionalContent
            ? "with-content"
            : "without-content";
        const footerClassName = DISPLAY_WELCOME_FOOTER
            ? "with-footer"
            : "without-footer";

        return (
            <div>
                <nav className="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
                    <div className="container">
                        <a className="navbar-brand">
                            <img src="./images/orange.png" />
                        </a>
                        <ul className="navbar-nav me-auto mb-0 mb-lg-0">
                            <li className="nav-item">
                                <a
                                    className="nav-link nav-linkcust"
                                    style={{
                                        fontSize: "16pt",
                                        fontWeight: "normal",
                                    }}
                                >
                                    {this.state.showSurvey ? (
                                        <span style={{ paddingBottom: "5px",display:"none" }}>
                                            Votre avis nous est précieux
                                        </span>
                                    ) : (
                                        <span>
                                            Ateliers numériques
                                            <br />
                                            Outil de visioconférences
                                        </span>
                                    )}
                                </a>
                            </li>
                        </ul>
                        {/* {this.state?.isLoggedIn && (
              <button
                className="btn btn-link btn-link-cust"
                style={{ float: "right", width: 150, textTransform: "inherit" }}
                onClick={() => this.logout()}
              >
                Déconnexion
              </button>
            )} */}
                        {this.state?.isLoggedIn &&
                            !this.state.showSurvey &&
                            !this.state.terminatePage && (
                                <div>
                                    <div>
                                        <button
                                            className="btn btn-link btn-link-cust"
                                            style={{
                                                float: "right",
                                                width: 150,
                                                textTransform: "inherit",
                                                pointerEvents: "none",
                                            }}
                                        >
                                            {
                                                this.state?.loggedInUser
                                                    ?.shop_name
                                            }
                                        </button>
                                    </div>
                                    <div>
                                        <button
                                            className="btn btn-link btn-link-cust"
                                            style={{
                                                float: "right",
                                                width: 150,
                                                textTransform: "inherit",
                                            }}
                                            onClick={() => this.logout()}
                                        >
                                            Déconnexion
                                        </button>
                                    </div>
                                </div>
                            )}
                    </div>
                </nav>

                {this.state?.isLoggedIn &&
                !this.state.showSurvey &&
                !this.state.terminatePage ? (
                    <div className="wrapper">
                        <div className="section-form container">
                            <div className="row">
                                {/* customer info */}
                                <div className="col-lg-7">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <input
                                                type="email"
                                                placeholder="Adresse e-mail du client"
                                                className="input mt-2"
                                                value={this.state.email}
                                                onChange={(e) =>
                                                    this.setState({
                                                        ...this.state,
                                                        email: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <input
                                                type="number"
                                                placeholder="Numéro de mobile du client"
                                                className="input mt-2"
                                                value={this.state.phoneNumber}
                                                onChange={(e) =>
                                                    this.setPhoneNumber(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="col-sm-2">
                                            <select
                                                className="input mt-2"
                                                value={this.state.gender}
                                                onChange={(e) =>
                                                    this.setState({
                                                        ...this.state,
                                                        gender: e.target.value,
                                                    })
                                                }
                                            >
                                                <option value="">- - -</option>
                                                <option value="Mme.">
                                                    Mme.
                                                </option>
                                                <option value="M.">M.</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-4">
                                            <input
                                                type="text"
                                                placeholder="Nom du client"
                                                className="input mt-2"
                                                value={this.state.clientName}
                                                onChange={(e) =>
                                                    this.setState({
                                                        ...this.state,
                                                        clientName:
                                                            e.target.value,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <input
                                                type="text"
                                                placeholder="Prénom du client"
                                                className="input mt-2"
                                                value={this.state.surname}
                                                onChange={(e) =>
                                                    this.setState({
                                                        ...this.state,
                                                        surname: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>
                                        <div className="col-sm-6">
                                            <DateTimePicker
                                                setDate={(e) => this.setDate(e)}
                                                dateMode={"nextAppointment"}
                                                appointmentDate={
                                                    this.state.appointmentDate
                                                }
                                            />
                                        </div>
                                        {/* <div className="col-sm-3">
                      <input
                        type="text"
                        placeholder="Date du RDV"
                        className="input mt-2"
                        onChange={(e) =>
                          this.setState({
                            ...this.state,
                            appointmentDate: e.target.value,
                          })
                        }
                      />
                    </div> */}
                                        <div className="col-sm-3 col-6">
                                            <select
                                                className="input mt-2"
                                                onChange={(e) =>
                                                    this.setState({
                                                        ...this.state,
                                                        hours: e.target.value,
                                                    })
                                                }
                                            >
                                                <option value="">Heure</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                                <option value="13">13</option>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                                <option value="19">19</option>
                                                <option value="20">20</option>
                                            </select>
                                        </div>
                                        <div className="col-sm-3 col-6">
                                            <select
                                                className="input mt-2"
                                                onChange={(e) =>
                                                    this.setState({
                                                        ...this.state,
                                                        minutes: e.target.value,
                                                    })
                                                }
                                            >
                                                <option value="">
                                                    Minutes
                                                </option>
                                                <option value="00">00</option>
                                                <option value="15">15</option>
                                                <option value="30">30</option>
                                                <option value="45">45</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                {/* comment */}
                                <div className="col-lg-5">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <textarea
                                                className="textarea mt-2"
                                                rows="2"
                                                cols="50"
                                                placeholder="Commentaire conseiller"
                                                value={this.state.comment}
                                                onChange={(e) =>
                                                    this.setState({
                                                        ...this.state,
                                                        comment: e.target.value,
                                                    })
                                                }
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-7">
                                    <div className="row">
                                        <div className="col-sm-6 btn-wrapper">
                                            <button
                                                className="btn btn-primary create-meeting-btn col-12 mt-2"
                                                onClick={() => {
                                                    if (
                                                        this.validateInputs(
                                                            "createMeeting"
                                                        )
                                                    ) {
                                                        this.openModal(
                                                            "createMeeting"
                                                        );
                                                    }
                                                }}
                                            >
                                                Créer la visioconférence
                                            </button>
                                        </div>
                                        <div className="col-sm-6 btn-wrapper">
                                            <button
                                                className="btn btn-light col-12 mt-2 start-meeting-btn"
                                                onClick={() => {
                                                    if (this.validateInputs()) {
                                                        this.openModal(
                                                            "startMeeting"
                                                        );
                                                    }
                                                }}
                                            >
                                                Démarrer
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.inputErr && (
                                <div className="row">
                                    <div className="col-7 err text-center mt-1">
                                        {this.state.inputErrMsg}
                                    </div>
                                </div>
                            )}
                            {this.state.loading && (
                                <div className="loading text-center">
                                    Chargement en cours...
                                </div>
                            )}
                        </div>
                        {/* History and details section */}
                        <div className="container history-details-wrapper">
                            {/* <div className="history-details-section"> */}
                            {/* <div className="d-flex justify-content-between history-title font-family text-secondary"> */}
                            <div className="text-dark row row-cust-top mb-2">
                                <div
                                    className="text-dark fw-bold lead col-sm-3 mt-3"
                                    style={{ fontSize: "18pt" }}
                                >
                                    Visioconférences
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-2">
                                        <DateTimePicker
                                            setFromDate={(e) =>
                                                this.setFromDate(e)
                                            }
                                            dateMode={"fromDate"}
                                            fromDate={this.state.fromDate}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="mb-2">
                                        <DateTimePicker
                                            setToDate={(e) => this.setToDate(e)}
                                            dateMode={"toDate"}
                                            toDate={this.state.toDate}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <input
                                        type={"text"}
                                        className="search form-control input"
                                        style={{ fontWeight: "normal" }}
                                        placeholder="Recherche Clients & Visioconférences"
                                        onChange={(e) =>
                                            this.searchMeeting(e.target.value)
                                        }
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="bottom"
                                        title="Rechercher par Client, commentaire, e-mail, numéro de mobile, visioconférence"
                                    />
                                </div>
                            </div>
                            {/* </div> */}
                            {/*  <div className="d-flex details d-none">
                  <div className="text-dark fw-bold lead">Details</div>
                  <div className="search-and-icons">
                     <img
                              src="./images/bell.svg"
                              className="mr-5 icon"
                          />
                          <img
                              src={"./images/calendar.svg"}
                              className="mr-5 icon"
                          />
                          <img
                              src={"./images/warning.svg"}
                              className="mr-5 icon"
                          /> 
                  </div>
                </div>*/}
                            {/* </div> */}
                            <div className="row">
                                <div className="col-12 text-dark ">
                                    {this.state?.recentMeetings?.map(
                                        (meeting) => {
                                            return (
                                                <div
                                                    className="single-history"
                                                    key={meeting.meeting_id}
                                                    onClick={() =>
                                                        this.selectedHistory(
                                                            meeting
                                                        )
                                                    }
                                                >
                                                    <div className="">
                                                        <div className="row">
                                                            <div className="col-sm-5">
                                                                <div
                                                                    className="text-darkcust badge bg-light badge-cust"
                                                                    style={{
                                                                        width: "100%",
                                                                        textAlign:
                                                                            "left",
                                                                    }}
                                                                >
                                                                    <span
                                                                        style={{
                                                                            textTransform:
                                                                                "uppercase",
                                                                        }}
                                                                    >
                                                                        {
                                                                            meeting
                                                                                ?.user_detail
                                                                                ?.user_name
                                                                        }{" "}
                                                                    </span>
                                                                    {
                                                                        meeting
                                                                            ?.user_detail
                                                                            ?.user_surname
                                                                    }
                                                                </div>
                                                                <div className="text-darkcust mt-2">
                                                                    Visioconférence{" "}
                                                                    {
                                                                        meeting.meeting_name
                                                                    }
                                                                    &nbsp; créée
                                                                    le{" "}
                                                                    {moment(
                                                                        meeting.addedon
                                                                    ).format(
                                                                        "DD/MM/YYYY à HH:mm"
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-5">
                                                                <div
                                                                    className="text-darkcust badge bg-light badge-cust"
                                                                    style={{
                                                                        width: "100%",
                                                                    }}
                                                                >
                                                                    RDV :&nbsp;
                                                                    {moment(
                                                                        meeting?.appointment_date
                                                                    ).format(
                                                                        "DD-MM-YYYY"
                                                                    )}{" "}
                                                                    {meeting?.appointment_time?.slice(
                                                                        0,
                                                                        5
                                                                    )}
                                                                </div>
                                                                <div
                                                                    className="text-darkcust mt-2"
                                                                    style={{
                                                                        textAlign:
                                                                            "center",
                                                                    }}
                                                                >
                                                                    Durée
                                                                    d'appel :{" "}
                                                                    {meeting.duration
                                                                        ? meeting.duration
                                                                        : "00:00"}
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-2 text-center">
                                                                <button
                                                                    className="join-btn btn btn-sm btn-light"
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        e.stopPropagation();

                                                                        this.joinMeeting(
                                                                            meeting.meeting_name,
                                                                            meeting.meeting_id,
                                                                            meeting
                                                                                ?.user_detail
                                                                                ?.user_email,
                                                                            meeting?.notes
                                                                        );
                                                                    }}
                                                                >
                                                                    Démarrer
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="commentdisplay mt-0">
                                                                {meeting
                                                                    ?.comment
                                                                    .length >
                                                                150
                                                                    ? meeting.comment.substring(
                                                                          0,
                                                                          150
                                                                      ) + "..."
                                                                    : meeting.comment}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="d-flex justify-content-betw">
                <div>
                  <div className="fw-bold">
                    {moment(meeting.addedOn).format(
                      "MM DD, YYYY hh:mm A"
                    )}
                  </div>
                  <div className="text-righ">2 minutes ago</div>
                </div>
              </div> */}
                                                </div>
                                            );
                                        }
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        {this.state.showSurvey ? (
                            <div
                                className="wrapper"
                            >
<TerminatePageViaSurvey/>
                            </div> 
                            
                        ) : this.state.terminatePage ? (
                            <div className="wrapper">
                                <TerminatePage />
                            </div>
                        ) : (
                            <div className="wrapper">
                                <Login login={() => this.login()} />
                            </div>
                        )}
                    </div>
                )}
                {this.state.confirmationModal && (
                    <ConfirmationModal
                        meetingMode={this.state.meetingMode}
                        startMeeting={(param) => this.startMeeting(param)}
                        createMeeting={() => this.createMeeting()}
                        handleClose={() => this.handleClose()}
                    />
                )}
                {this.state.showHistoryModal && (
                    <HistoryModal
                        selectedHistory={this.state.selectedHistory}
                        handleClose={(arg) => this.closeHistoryModal(arg)}
                        joinMeeting={(name, id, notes) =>
                            this.joinMeeting(name, id, notes)
                        }
                        getRecentMettingsByDate={(fromDate, toDate) =>
                            this.getRecentMettingsByDate(fromDate, toDate)
                        }
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                    />
                )}
            </div>
        );
    }

    /**
     * Renders the insecure room name warning.
     *
     * @inheritdoc
     */
    _doRenderInsecureRoomNameWarning() {
        return (
            <div className="insecure-room-name-warning">
                <Icon src={IconWarning} />
                <span>{this.props.t("security.insecureRoomNameWarning")}</span>
            </div>
        );
    }

    /**
     * Prevents submission of the form and delegates join logic.
     *
     * @param {Event} event - The HTML Event which details the form submission.
     * @private
     * @returns {void}
     */
    _onFormSubmit(event) {
        event.preventDefault();
        this.sendEmailsArray();
    }

    /**
     * Overrides the super to account for the differences in the argument types
     * provided by HTML and React Native text inputs.
     *
     * @inheritdoc
     * @override
     * @param {Event} event - The (HTML) Event which details the change such as
     * the EventTarget.
     * @protected
     */
    _onRoomChange(value) {
        super._onRoomChange(value);
        this.setState({ ...this.state, room: value });
    }

    /**
     * Callback invoked when the desired tab to display should be changed.
     *
     * @param {number} tabIndex - The index of the tab within the array of
     * displayed tabs.
     * @private
     * @returns {void}
     */
    _onTabSelected(tabIndex) {
        this.setState({ selectedTab: tabIndex });
    }

    /**
     * Renders the footer.
     *
     * @returns {ReactElement}
     */
    _renderFooter() {
        const { t } = this.props;
        const {
            MOBILE_DOWNLOAD_LINK_ANDROID,
            MOBILE_DOWNLOAD_LINK_F_DROID,
            MOBILE_DOWNLOAD_LINK_IOS,
        } = interfaceConfig;

        return (
            <footer className="welcome-footer">
                <div className="welcome-footer-centered">
                    <div className="welcome-footer-padded">
                        <div className="welcome-footer-row-block welcome-footer--row-1">
                            <div className="welcome-footer-row-1-text">
                                {t("welcomepage.jitsiOnMobile")}
                            </div>
                            <a
                                className="welcome-badge"
                                href={MOBILE_DOWNLOAD_LINK_IOS}
                            >
                                <img
                                    alt={t("welcomepage.mobileDownLoadLinkIos")}
                                    src="./images/app-store-badge.png"
                                />
                            </a>
                            <a
                                className="welcome-badge"
                                href={MOBILE_DOWNLOAD_LINK_ANDROID}
                            >
                                <img
                                    alt={t(
                                        "welcomepage.mobileDownLoadLinkAndroid"
                                    )}
                                    src="./images/google-play-badge.png"
                                />
                            </a>
                            <a
                                className="welcome-badge"
                                href={MOBILE_DOWNLOAD_LINK_F_DROID}
                            >
                                <img
                                    alt={t(
                                        "welcomepage.mobileDownLoadLinkFDroid"
                                    )}
                                    src="./images/f-droid-badge.png"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }

    /**
     * Renders tabs to show previous meetings and upcoming calendar events. The
     * tabs are purposefully hidden on mobile browsers.
     *
     * @returns {ReactElement|null}
     */
    _renderTabs() {
        if (isMobileBrowser()) {
            return null;
        }

        const { _calendarEnabled, _recentListEnabled, t } = this.props;

        const tabs = [];

        if (_calendarEnabled) {
            tabs.push({
                label: t("welcomepage.calendar"),
                content: <CalendarList />,
            });
        }

        if (_recentListEnabled) {
            tabs.push({
                label: t("welcomepage.recentList"),
                content: <RecentList />,
            });
        }

        if (tabs.length === 0) {
            return null;
        }

        return (
            <Tabs
                onSelect={this._onTabSelected}
                selected={this.state.selectedTab}
                tabs={tabs}
            />
        );
    }

    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * additional card shown near the tabs card.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalCardRef(el) {
        this._additionalCardRef = el;
    }

    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * welcome page content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the welcome page content.
     * @private
     * @returns {void}
     */
    _setAdditionalContentRef(el) {
        this._additionalContentRef = el;
    }

    /**
     * Sets the internal reference to the HTMLDivElement used to hold the
     * toolbar additional content.
     *
     * @param {HTMLDivElement} el - The HTMLElement for the div that is the root
     * of the additional toolbar content.
     * @private
     * @returns {void}
     */
    _setAdditionalToolbarContentRef(el) {
        this._additionalToolbarContentRef = el;
    }

    /**
     * Sets the internal reference to the HTMLInputElement used to hold the
     * welcome page input room element.
     *
     * @param {HTMLInputElement} el - The HTMLElement for the input of the room name on the welcome page.
     * @private
     * @returns {void}
     */
    _setRoomInputRef(el) {
        this._roomInputRef = el;
    }

    /**
     * Returns whether or not an additional card should be displayed near the tabs.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalCard() {
        return (
            interfaceConfig.DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD &&
            this._additionalCardTemplate &&
            this._additionalCardTemplate.content &&
            this._additionalCardTemplate.innerHTML.trim()
        );
    }

    /**
     * Returns whether or not additional content should be displayed below
     * the welcome page's header for entering a room name.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalContent() {
        return (
            interfaceConfig.DISPLAY_WELCOME_PAGE_CONTENT &&
            this._additionalContentTemplate &&
            this._additionalContentTemplate.content &&
            this._additionalContentTemplate.innerHTML.trim()
        );
    }

    /**
     * Returns whether or not additional content should be displayed inside
     * the header toolbar.
     *
     * @private
     * @returns {boolean}
     */
    _shouldShowAdditionalToolbarContent() {
        return (
            interfaceConfig.DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT &&
            this._additionalToolbarContentTemplate &&
            this._additionalToolbarContentTemplate.content &&
            this._additionalToolbarContentTemplate.innerHTML.trim()
        );
    }
}

export default translate(connect(_mapStateToProps)(WelcomePage));
